export type JobDescriptionFormFields = {
  jobId: string;
  description: string;
};

const edit = (jobId: string, description: string) => ({
  jobId,
  description,
});

const toMutation = ({jobId, description}: JobDescriptionFormFields) => ({
  jobId,
  notes: description,
});

const JobNotesForm = {
  edit,
  toMutation,
};

export default JobNotesForm;
